"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Popover = void 0;
const react_1 = __importStar(require("react"));
const icons_1 = require("../icons");
const tooltip_1 = require("../tooltip");
const styles_1 = require("./styles");
const addPrefix = (suffix) => {
    const prefix = 'popover';
    return `${prefix}-${suffix}`;
};
const Popover = (props) => {
    const { bubbleNotchHorizontalPosition = '10', backgroundColor = 'transparent', children, headerText, position = 'bottom', closePopover } = props;
    const useOutOfFocusListener = (ref) => {
        (0, react_1.useEffect)(() => {
            const handleBlur = (e) => {
                if (ref.current && !ref.current.contains(e.target)) {
                    closePopover();
                }
            };
            document.addEventListener('mousedown', handleBlur);
            return () => document.removeEventListener('mousedown', handleBlur);
        }, [ref]);
    };
    const wrapperRef = (0, react_1.useRef)(null);
    useOutOfFocusListener(wrapperRef);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(tooltip_1.Tooltip, { position: position, backgroundColor: backgroundColor },
            react_1.default.createElement(styles_1.PopoverContainer, { ref: wrapperRef },
                react_1.default.createElement(styles_1.PopoverInner, null,
                    !!headerText && (react_1.default.createElement(styles_1.PopoverHeaderContainer, null,
                        react_1.default.createElement(styles_1.HeaderText, { bold: true, "data-cy": addPrefix('header-text') }, headerText))),
                    react_1.default.createElement(styles_1.PopoverCloseButton, { "data-cy": addPrefix('close-button'), "aria-label": "close", tabIndex: 0, onClick: () => closePopover() },
                        react_1.default.createElement(icons_1.RioCloseIcon, { size: 16 })),
                    react_1.default.createElement(styles_1.PopoverChildrenContainer, null, children)))),
        react_1.default.createElement(styles_1.PopoverArrowBorder, { bubbleNotchHorizontalPosition: bubbleNotchHorizontalPosition },
            react_1.default.createElement(styles_1.PopoverArrow, null))));
};
exports.Popover = Popover;
